import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const SUBMIT_MESSAGES = strings.sendoutsV2.alerts.submitMessages;

const buildCreateSendoutInterviewAlert = ({ severity, body }) => ({
  severity,
  title: strings.formatString(SUBMIT_MESSAGES[severity].title, {
    processType: strings.sendoutsV2.processTypes.interview,
    action:
      severity === 'success'
        ? SUBMIT_MESSAGES.actions.scheduled
        : SUBMIT_MESSAGES.actions.scheduling
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const createSendoutInterview = async ({ sendoutId, payload }) => {
  try {
    const response = await API.post(
      `${Endpoints.SendoutInterviews.replace(':id', sendoutId)}`,
      payload
    );

    if (response.status !== HTTPStatusCodes.Ok) {
      return {
        success: false,
        response,
        alert: buildCreateSendoutInterviewAlert({
          severity: 'error',
          body: strings.formatString(SUBMIT_MESSAGES.unexpectedStatus, { status: response.status })
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildCreateSendoutInterviewAlert({ severity: 'success' })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildCreateSendoutInterviewAlert({
        severity: 'error',
        body: getErrorMessage(error, error?.message ?? strings.shared.ui.unknownError.title)
      })
    };
  }
};
